export default __webpack_public_path__ + "static/media/users.bca29e6d.svg";